import { render, staticRenderFns } from "./classPushPartner.vue?vue&type=template&id=05fe3457&scoped=true"
import script from "./classPushPartner.vue?vue&type=script&lang=js"
export * from "./classPushPartner.vue?vue&type=script&lang=js"
import style0 from "./classPushPartner.vue?vue&type=style&index=0&id=05fe3457&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fe3457",
  null
  
)

export default component.exports